/**
 * 
 * @param {number} amount 
 * @returns string | null
 */
export function currencyFormatter(amount: number): string | null {
    if (isNaN(amount)) return null;

    const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2, // Ensure two decimal places are displayed
        maximumFractionDigits: 2
    });

    return formatter.format(amount);
}